import type { FC, ReactNode } from 'react';
import React from 'react';
import { Box } from '@edreamsodigeo/prisma-design-system';

interface LeftContentWrapperProps {
  children?: ReactNode;
}

const LeftContentWrapper: FC<LeftContentWrapperProps> = ({ children }) => {
  return (
    <Box minWidth="70px" maxWidth="70px">
      {children}
    </Box>
  );
};

export default LeftContentWrapper;
